import React, {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {SearchMaskPsoMarketUserOptionsInlineComponent} from "./search-mask-pso-market-user-options-inline.component";
import {useServices} from "../../../hooks/use-services.hook";
import {MediumButton} from "../../../basic-components/buttons/medium-button";
import {PsoUserOptionsEnum} from "../../../services/flight-search/flight-search-controller/pso.enums";
import {CheckMarkIcon} from "../../../assets/svg/check-mark.icon";
import {ITooltipController, TooltipComponent, TooltipToggleBehaviorEnum} from "../../tooltip/tooltip.component";
import {
    IFlightSearchControllerViewModel
} from "../../../services/flight-search/flight-search-controller/flight-search-controller-view-model.interface";
import {IPsoMarket} from "../../../services/stations/pso-market.interface";


const ContainerBox = styled.div`
    
`

const PsoButtonBox = styled(MediumButton)`
    position: relative;
    display: flex;
    flex-direction: row;
    gap: ${props => props.theme.spacing.spacing8};
    border-radius: 20px;
    padding: ${props => props.theme.spacing.spacing8} ${props => props.theme.spacing.spacing16};
`


const PsoButtonCheckmarkBox = styled.span`
    color: ${props => props.theme.colors.primary};
`


const ToolTipContentBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${props => props.theme.spacing.spacing12};
    padding: ${props => props.theme.spacing.spacing16};
`

interface SearchMaskPsoMarketUserOptionsPopperComponentProps {
    searchController: IFlightSearchControllerViewModel;
    psoMarket: IPsoMarket;
}


export const SearchMaskPsoMarketUserOptionsPopperComponent: React.FC<SearchMaskPsoMarketUserOptionsPopperComponentProps> = observer((props) => {
    const services = useServices();
    const isFirstTime = useRef(true);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const tooltipControllerRef = useRef<ITooltipController | null>(null);
    const searchController =  props.searchController;


    useEffect(() => {
        if(isFirstTime.current) {
            isFirstTime.current = false;
            tooltipControllerRef.current?.open();
        }
    }, []);

    const renderCheckMark = () => {
        if(searchController.psoUserOption === PsoUserOptionsEnum.None) {
            return null;
        }

        return (
            <PsoButtonCheckmarkBox>
                <CheckMarkIcon size={0.8}/>
            </PsoButtonCheckmarkBox>

        )
    }


    return (
        <ContainerBox ref={containerRef}>
            <PsoButtonBox>
                {renderCheckMark()}
                <span>{services.language.translate('PSO Route options')}</span>
            </PsoButtonBox>
            <TooltipComponent placement={"top"}
                              targetRef={containerRef}
                              showCloseButton={true}
                              tooltipControllerRef={tooltipControllerRef}
                              toggleBehavior={TooltipToggleBehaviorEnum.OnTargetClick}>
                <ToolTipContentBox>
                    <SearchMaskPsoMarketUserOptionsInlineComponent searchController={searchController} psoMarket={props.psoMarket}/>
                </ToolTipContentBox>

            </TooltipComponent>
        </ContainerBox>
    )
})